module.exports = __webpack_public_path__ + "static/img/ic_bus@2x.945e3a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_bus@2x.png
// module id = wpqE
// module chunks = 1